/**
 * is方法的实现, 类似media query的bnf
 * tokenize + parse
 * BNF:
 * rule_list: <rule>[,<rule>]*
 * rule: <expression>[and <expression>]*
 * expression:(<identity>[<operator><version>]?)
 * identity:ios|android|passenger|driver|lite
 * operator: > | < | = | >= | <=
 * version: [\d\.]
 * @author huangyiustb
 * @email huangyiustb@didichuxing.com
 */
import { each } from '../util'

import { compareAppVersion, compareSysVersion, app } from './app'

const identRE = /^\w+(\.\w+)?/
const versionRE = /^[\d\._]+/
const opRE = /^\s*[>=<]+\s*/
const commaRE = /^\s*,\s*/
const andRE = /^\s*and\s*/

const ERR_IDENTITY = 0
const ERR_VERSION = 1

const errMsg = ['identity is not valid', 'version is not valid']

const SYSTEM = 0
const APP = 1

const identityList = {
  passenger: {
    type: APP,
    compare: compareAppVersion
  },
  driver: {
    type: APP,
    compare: compareAppVersion
  },
  finance: {
    type: APP,
    compare: compareAppVersion
  },
  'daijia.driver': {
    type: APP,
    compare: compareAppVersion
  },
  lite: {
    type: APP,
    compare: compareAppVersion
  },
  ios: {
    type: SYSTEM,
    compare: compareSysVersion
  },
  android: {
    type: SYSTEM,
    compare: compareSysVersion
  },
  beatles: {
    type: APP,
    compare: compareAppVersion,
  },
  blord: {
    type: APP,
    compare: compareAppVersion,
  },
};

// let tokenCache = {};
export function initIS(DDBridge) {
  DDBridge.is = function (rule) {
    try {
      let groups = tokenize(rule);
      return parse(groups);
    } catch (e) {
      console.error(e.message);
    }
  }
}

/**
 * 词法分析
 * @param rule
 * @example 'passenger'
 * @example 'passenger>=5.0'
 * @example 'passenger>=5.0 and ios>9.3.2'
 * @example 'passenger>=5.0 and ios>9.3.2, driver >=3.0, lite >=1.0'
 * @return Array
 */
function tokenize(rule) {
  // if (tokenCache[rule]) {
  // 	return tokenCache[rule];
  // }
  let soFar = rule
  // 根据comma分组
  let groups = []
  let matched

  while (soFar) {
    let tokens
    let match = commaRE.exec(soFar)
    if (!matched || match) {
      // 删除comma
      if (match) {
        soFar = soFar.slice(match[0].length) || soFar
      }
      tokens = []
      groups.push(tokens)
    }

    matched = false

    let more = true
    let error = false
    // 解析每个表达式
    do {
      let expression = {}
      // 拿到identity
      match = identRE.exec(soFar)
      if (match) {
        matched = match.shift()
        expression.identity = matched
        soFar = soFar.slice(matched.length)
      } else {
        error = ERR_IDENTITY
        break
      }
      // 再尝试拿操作符
      match = opRE.exec(soFar)
      if (match) {
        matched = match.shift()
        expression.operator = matched.trim()
        soFar = soFar.slice(matched.length)

        // 如果有操作符,就必须有版本号
        match = versionRE.exec(soFar)
        if (match) {
          matched = match.shift()
          expression.version = matched
          soFar = soFar.slice(matched.length)
        } else {
          error = ERR_VERSION
          break
        }
      }
      tokens.push(expression)
      // 最后拿and
      match = andRE.exec(soFar)
      if (match) {
        matched = match.shift()
        soFar = soFar.slice(matched.length)
        more = true
      } else {
        more = false
      }
    } while (more)

    if (error !== false) {
      throw new Error(`the rule is error, ${errMsg[error]}`)
    }
  }
  // cache
  // tokenCache[rule] = groups;
  return groups
}

/**
 * 解析词法分析的结果
 * @param group
 * @return Boolean
 */
function parse(groups) {
  let ret = false
  each(groups, (tokens) => {
    let result = true
    each(tokens, (expression) => {
      let { identity, operator, version } = expression
      // 白名单
      let ident = identityList[identity]
      if (!ident) {
        throw new Error(`unknown identity:${identity}!`)
      }
      let equal = false
      let type = ident.type
      if (type === SYSTEM) {
        equal = app.system === identity
      } else if (type === APP) {
        if (identity == 'driver') {
          equal = (app.env === identity) || app.driver
        } else {
          equal = app.env === identity
        }
      }
      if (!operator || !equal) {
        result = result && equal
      } else {
        let compareFn = ident.compare
        result = result && compareFn(operator, version)
      }
    })
    ret = ret || result
  })
  return ret
}



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridge/is.js